import { Injectable } from "@angular/core";
import { PericiaDTO, PericiaListDTO } from "app/model/dtos/mob/pericia.dto";
import { HttpGet, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class PericiaController {
    constructor(){}
    
    async find(filtros?: IFilter): Promise<PericiaListDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/pericias',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new PericiaListDTO()
			)
		);
		return await quark.call();
	}

    async update(pericias: PericiaDTO[]): Promise<Array<PericiaDTO>> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/pericias/pericias',
					environment: environment
				}),
				data: new JSONData(pericias)
			}),
			new HttpResponse(
				new Array<PericiaDTO>()
			)
		);
		return await quark.call();
	}

    async generateReport(filtros?: IFilter): Promise<Blob> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/relatorio/cartoes',
					environment: environment,
					filter: filtros
				}),
				responseType: 'Blob'
			}),
			new HttpResponse(
				new Blob())
				);
				return await quark.call();
			}
}